var flashcardSettings = require('./flashcard_settings');


var SettingsModal = function(global,callback) {

    var modalDiv = $('#'+ global.modal);
    $(modalDiv).on('hidden.bs.modal', function (e) {

        if ( typeof global.flashcards == 'undefined' || global.flashcards.length == 0 ) {
            document.location.href = global.dashboardLink;
        }

    });
    var modalcontentstr = '<div class="modal-header">Create Flashcards</div><div class="modal-body feedback">' +
        '<div class="settings-table-wrapper"></div>' +
        '</div><div class="modal-footer"><button id="cancel-button" type="button" class="btn btn-default">Cancel</button><button type="button" class="btn btn-default" id="start-button">Start</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);
    $(modalDiv).find('.modal-content').append(modalContent);

    $('#cancel-button').click(function() {
        document.location.href = dashboardLink;
    });


    var tableWrapper = $(modalContent).find('.settings-table-wrapper');

    var url = apiUrl + 'flashcard/getStats/';
    $.ajax({
        url: url,
        dataType: 'json',
        success:function(response) {

            global.chapters = response.chapters;

            var flashcard_settings = flashcardSettings(response);

            tableWrapper.html('');
            tableWrapper.append(flashcard_settings);

            $(modalDiv).find('#start-button').click(function() {

                // get the questions, call the callback.
                var total = 0;
                var data = {chapters: []};

                if ($('#all_chapters').prop('checked') == true) {
                    data.all_chapters = 'on';
                    data.all_chapters_num = $('#all_chapters_num').val();
                    total = data.all_chapters_num;
                } else {
                    $('.select_chapter:checked').each(function () {
                        var id = $(this).val();
                        var val = parseInt($('#num_' + id).val());
                        data.chapters.push({id: id, num: val});
                        total += val;
                    });
                }


                if (total == 0) {
                    alert('Please choose a number of questions.');
                // } else if (total > 100) {
                //     alert('Total flashcards must be less than 100.')
                } else {
                    var url = apiUrl + 'flashcard/create/';
                    $.ajax({
                        url: url,
                        data: data,
                        dataType: 'json',
                        success:function(response) {
                            global.flashcards = response.data;

                            callback();
                        }
                    });

                }
            });
            $(modalDiv).modal();

        }
    })


}

module.exports = SettingsModal;


//////////////////
// WEBPACK FOOTER
// ./src/flashcard_settings_modal.js
// module id = 313
// module chunks = 0